import { render } from "./ModalLabel.vue?vue&type=template&id=c8660674&scoped=true"
import script from "./ModalLabel.vue?vue&type=script&lang=js"
export * from "./ModalLabel.vue?vue&type=script&lang=js"

import "./ModalLabel.vue?vue&type=style&index=0&id=c8660674&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c8660674"

export default script